// Modules
import { MakeLogin } from 'main/factories/modules/Authentication/login-factory';
import { ProtectedForgetPasswordPage } from 'presentation/app/modules/Authentication/pages/authentication-password-reset/send-password-reset-code/pages/ProtectedForgetPasswordPage';
import { ProtectedPageSetNewPassword } from 'presentation/app/modules/Authentication/pages/authentication-password-reset/set-new-password/pages/ProtectedPageSetNewPassword';
import { ProtectedVerifyCodePage } from 'presentation/app/modules/Authentication/pages/authentication-password-reset/verify-code/pages/ProtectedVerifyCodePage';
import { Logout } from 'presentation/app/modules/Authentication/pages/logout';
import { SignInViaImpersonate } from 'presentation/app/modules/Authentication/pages/sign-in-via-impersonate';

const publicRoutes = [
  { path: '/login', component: <MakeLogin /> },
  { path: '/logout', component: <Logout /> },
  {
    path: '/login/impersonate',
    component: <SignInViaImpersonate />,
  },
  {
    path: '/redefinir-senha',
    component: <ProtectedForgetPasswordPage />,
  },
  {
    path: '/redefinir-senha/codigo-verificacao',
    component: <ProtectedVerifyCodePage />,
  },
  {
    path: '/redefinir-senha/nova-senha',
    component: <ProtectedPageSetNewPassword />,
  },
];

export { publicRoutes };
